import standard from "../img/shape/shape-standard.svg";
import swooping from "../img/shape/shape-swooping.svg";
import sagging from "../img/shape/shape-sagging.svg";
import large from "../img/shape/shape-large.svg";
import small from "../img/shape/shape-small.svg";
import tubular from "../img/shape/shape-tubular.svg";
import pigeon from "../img/shape/shape-pigeon.svg";

export default [
  {
    img: standard,
    value: "Standard",
    description: "Breasts have evenly distributed fatty tissue on the top and bottom. Easiest to fit shape. #jealous",
  },
  {
    img: swooping,
    value: "Swooping",
    description: "Breasts have more fatty tissue located on the bottom and nipple tends to point up.",
  },
  {
    img: sagging,
    value: "Sagging",
    description: "Breasts have lost elasticity and point downward. By wearing a correct fitting bra will prevent the breast tissue from stretching out more.",
  },
  {
    img: large,
    value: "Large",
    description: "Breasts have lost elasticity and point downward. By wearing a correct fitting bra will prevent the breast tissue from stretching out more.",
  },
  {
    img: small,
    value: "Small",
    description: "Breasts have a smaller amount of fatty tissue and is mostly seen in women who are AAA-C cup size.",
  },
  {
    img: tubular,
    value: "Tubular",
    description: "Breasts look like pointy triangles or torpedoes and tend to be more fuller on bottom then at the top of the breast.",
  },
  {
    img: pigeon,
    value: "Pigeon",
    description: "Breasts look flattened, fatty tissue has been lost, and tissue elasticity has been stretched out.",
  },
]
